import React from 'react';
import { LocationTypes } from '../locationTypes';

const variant: LocationTypes.TVariantModes = 'cover-image';

export const VariantContext = React.createContext<LocationTypes.TVariantModes>(
  variant
);
